import {InvoiceHistoryList} from '../../../invoices.model';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {LoaderState} from '../../../../../../core/state/utils/loader/loader-state';
import {StateUtils} from '@spartacus/core';
import {getInvoicesState, StateWithInvoices} from '../../../store/selectors/custom-invoice.selector';

export const INVOICE_LIST_SELECTOR = 'invoicesList';

export const getInvoicesHistoryState: MemoizedSelector<StateWithInvoices, LoaderState<InvoiceHistoryList>> =
  createSelector(getInvoicesState, (state) => state[INVOICE_LIST_SELECTOR]);

export const getInvoicesHistoryValue: MemoizedSelector<StateWithInvoices, InvoiceHistoryList> =
  createSelector(getInvoicesHistoryState, (state) => StateUtils.loaderValueSelector(state));

export const getInvoicesHistorySuccess: MemoizedSelector<StateWithInvoices, boolean> =
  createSelector(getInvoicesHistoryState, (state) => StateUtils.loaderSuccessSelector(state));

export const getInvoicesHistoryLoader: MemoizedSelector<StateWithInvoices, boolean> =
  createSelector(getInvoicesHistoryState, (state) => StateUtils.loaderLoadingSelector(state));

export const getInvoicesHistoryError: MemoizedSelector<StateWithInvoices, boolean> =
  createSelector(getInvoicesHistoryState, (state) => StateUtils.loaderErrorSelector(state));


